import { render, staticRenderFns } from "./indicator.vue?vue&type=template&id=4d84417b&"
import script from "./indicator.vue?vue&type=script&lang=js&"
export * from "./indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports